import React, { Component } from 'react'
import { DataTable } from '@softwaredev_cegeka/stix-data-table'
import { Alert, Pagination } from '@softwaredev_cegeka/stix-core'

// Style
import './asyncDataTable.scss'

class AsyncDataTable extends Component {
    render() {
        const columns = this.props.columns.map(col => ({ ...col }))
        const { loading, results, page, totalPages, loadData, className } =
            this.props

        return (
            <div className={`${className} async-data-table`}>
                <DataTable
                    {...this.props}
                    loading={!results.length || loading}
                    data={
                        results.length ? results : [...Array(7)].map(_ => ({}))
                    }
                    columns={columns}
                    variant={'compact'}
                />
                {results.length === 0 && !loading && (
                    <div className="async-data-table-message">
                        <Alert variant="info">0 results found</Alert>
                    </div>
                )}

                {totalPages > 1 && (
                    <div className="pagination-wrapper">
                        <Pagination
                            lastPage={totalPages}
                            currentPage={page}
                            onClick={page => loadData(page)}
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default AsyncDataTable
